import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-surface text-center px-4">
      <div className="text-5xl">🧭</div>
      <h1 className="text-xl font-semibold text-gray-200">Seite nicht gefunden</h1>
      <Link to="/" className="btn-primary mt-2">Zurück zum Dashboard</Link>
    </div>
  );
}
